import StationRoute from './StationRoute';
import { fetchStationData } from '../fetchDataFromStrapi';

// Diese Funktion generiert die dynamischen Routen für die Tasten
const generateRoutes = async () => {
  try {
    const stations = await fetchStationData();

    return stations.flatMap(({ name, buttonCount }) =>
      StationRoute({ station: name, buttonCount }),
    );
  } catch (error) {
    console.error('Fehler beim Generieren der Routen:', error);
    return [];
  }
};

export default generateRoutes;
